export enum CampaignRunStatuses {
  Scheduled = 1,
  InProgress = 2,
  Completed = 3,
  Canceled = 4,
}
